import { Action, combineReducers } from '@ngrx/store';

import {
  SET_LOGIN_VIEW,
  SET_LOST_PASSWORD_VIEW,
  SET_REGISTER_VIEW
} from '../actions';

const initialLoginPageState = {
  loading: <boolean>false,
  message: <string>null
}

const initialLostPasswordPageState = {
  loading: <boolean>false,
  message: <string>null,
  error  : <boolean>null
}

const initialRegisterPageState = {
  loading: <boolean>false,
  message: <string>null
}

export function loginPageReducer(state = initialLoginPageState, action: Action) {
  switch (action.type) {
    case SET_LOGIN_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

export function lostPasswordPageReducer(state = initialLostPasswordPageState, action: Action) {
  switch (action.type) {
    case SET_LOST_PASSWORD_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

export function registerPageReducer(state = initialRegisterPageState, action: Action) {
  switch (action.type) {
    case SET_REGISTER_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

export const preAuthReducers = combineReducers({
  loginPage: loginPageReducer,
  lostPasswordPage: lostPasswordPageReducer,
  registerPage: registerPageReducer
});



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/reducers/pre-auth.ts